// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { initializeFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const DEFAULT_AUTH_DOMAIN = "sink.mqgauss.com";
const LEGACY_FIREBASE_AUTH_DOMAIN = "second-brain-2d68a.firebaseapp.com";
const configuredAuthDomain = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN;

const firebaseConfig = {
  apiKey: "AIzaSyAIRK4glAqV4JWtnuENALvIXJb3mllvxi0",
  authDomain: configuredAuthDomain && configuredAuthDomain !== LEGACY_FIREBASE_AUTH_DOMAIN
    ? configuredAuthDomain
    : DEFAULT_AUTH_DOMAIN,
  projectId: "second-brain-2d68a",
  storageBucket: "second-brain-2d68a.firebasestorage.app",
  messagingSenderId: "1089752231718",
  appId: "1:1089752231718:web:c791e45143c91491c1dbe7",
  measurementId: "G-YHQ7ZLLRXW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Analytics is initialized conditionally in Root.jsx to comply with privacy requirements

const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true,
});
const auth = getAuth(app);

export { app, db, auth };
